import { useCookies } from 'vue3-cookies'
import type { MutationTree } from 'vuex'
import type { UserState } from './types'
import {
  GET_ME,
  GET_LIST_USERS,
  GET_LIST_END_USERS,
  SET_CURRENT_PAGE,
  SET_SELECTED_ROWS,
} from './types'
import { LOGIN_ID_KEY } from 'core/constants'

const { cookies } = useCookies()

export const mutations: MutationTree<UserState> = {
  [GET_ME](state: UserState, user: UserModel) {
    cookies.set(LOGIN_ID_KEY, user?.email || '', 60 * 60 * 24)
    state.user = user
  },
  [GET_LIST_USERS](state: UserState, users: UserModel[]) {
    state.users = users
  },
  [GET_LIST_END_USERS](state: UserState, endUsers: UserModel[]) {
    state.endUsers = endUsers
  },
  [SET_CURRENT_PAGE](state: UserState, numPage: number) {
    state.currentPage = numPage
  },
  [SET_SELECTED_ROWS](state: UserState, rows: number) {
    state.selectedRows = rows
  },
}
